/**
 * useHaptics — wrapper around @capacitor/haptics with no-op fallback on web.
 */
import { useCallback } from "react";

type Style = "light" | "medium" | "heavy" | "success" | "warning" | "error" | "selection";

export function useHaptics() {
  const trigger = useCallback(async (style: Style = "light") => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { Haptics, ImpactStyle, NotificationType } = await import("@capacitor/haptics");
      switch (style) {
        case "light":     return Haptics.impact({ style: ImpactStyle.Light });
        case "medium":    return Haptics.impact({ style: ImpactStyle.Medium });
        case "heavy":     return Haptics.impact({ style: ImpactStyle.Heavy });
        case "success":   return Haptics.notification({ type: NotificationType.Success });
        case "warning":   return Haptics.notification({ type: NotificationType.Warning });
        case "error":     return Haptics.notification({ type: NotificationType.Error });
        case "selection": return Haptics.selectionStart();
      }
    } catch {
      // web / not installed → no-op
    }
  }, []);

  return { trigger };
}
